function inlineFilterItems(instance) {
  return [
    {
      id: 'all',
      label: instance.$t('salesOrder.status.all'),
    },
    {
      id: 'DRAFT',
      label: instance.$t('salesOrder.status.draft'),
    },
    {
      id: 'CONFIRMED',
      label: instance.$t('salesOrder.status.confirmed'),
    },
    {
      id: 'ASSIGNED',
      label: instance.$t('salesOrder.status.assigned'),
    },
    {
      id: 'COMPLETED',
      label: instance.$t('salesOrder.status.completed'),
    },
    {
      id: 'CANCELED',
      label: instance.$t('salesOrder.status.canceled'),
    },
  ]
}

export default inlineFilterItems
